import { APP_ID, NgModule, TransferState } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { RoutingModule } from './routing/routing.module';
import { JssLayoutService } from './layout/jss-layout.service';
import { JssContextService } from './jss-context.service';
import { AppComponentsModule } from './components/app-components.module';
import { AppComponent } from './app.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { JssTranslationClientLoaderService } from './i18n/jss-translation-client-loader.service';
import { JssTranslationLoaderService } from './i18n/jss-translation-loader.service';
import { GraphQLModule } from './jss-graphql.module';
import { JssDataFetcherService } from './jss-data-fetcher.service';
import { JssMetaService } from './jss-meta.service';
import { JssStylingService } from './JssStylingService';
import { CustomDeviceDetectorService } from './services/CustomDeviceDetectorService';
// import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { IMaskModule } from 'angular-imask';
import { ApiService } from './services/ApiService';
import { RestService } from './services/RestService';
import { environment } from '../environments/environment';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DynamicScriptLoaderService } from './services/dynamic-script-loader.service';
import { SearchService } from './services/search.service';


@NgModule({
  imports: [
    HttpClientModule,
    GraphQLModule,
    RoutingModule,
    RecaptchaV3Module,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: () => new JssTranslationClientLoaderService(new JssTranslationLoaderService()),
        deps: [HttpClient, TransferState],
      },
    }),
    AppComponentsModule,
    // FormsModule,
    ReactiveFormsModule,
    IMaskModule 
  ],
  providers: [
    // The token is needed in cases when multiple applications are bootstrapped on a page
    { provide: APP_ID, useValue: 'my-app' },
    SearchService,
    JssContextService,
    JssDataFetcherService,
    JssLayoutService,
    JssMetaService,
    JssStylingService,
    CustomDeviceDetectorService,
    ApiService,
    RestService,
    DynamicScriptLoaderService,
    // IMPORTANT: you must set the base href with this token, not a <base> tag in the HTML.
    // the Sitecore Experience Editor will not work correctly when a base tag is used.
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaSiteKey } 
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
